<generic-comp [initData]="compData" *ngIf="compData"></generic-comp>
